function checkCookies(name) {
  return document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
}

function addCookie(name, value, days = 30, path) {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = `; expires=${date.toGMTString()}`;
  }

  const dir = path || '/';
  document.cookie = `${name}=${value}${expires}; path=${dir}`;
}


class Offer {
  constructor() {
    this.settings = JSON.parse(document.getElementById('Offer-data').innerHTML);
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    this.refresh()
  }

  cartUpdateUnsubscriber = undefined;

  refresh() {
    const matchCookie = checkCookies('refresh-gift');
    if (matchCookie) return;

    this.onCartUpdate();
    addCookie('refresh-gift', true, 1);
  }

  init() {
    this.onCartUpdate = this.onCartUpdate.bind(this);

    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate);
  }

  toggleLoading(isLoading = true) {
    const checkoutButton = this.cart.querySelector('[name="checkout"]');
    const spinner = checkoutButton.querySelector('.loading-overlay__spinner');
    const cartItemElements = this.cart.querySelectorAll(`[id^="CartItem-"] button[name=minus], [id^="CartItem-"] button[name=plus]`);
    const cartDrawerItemElements = this.cart.querySelectorAll(`[id^="CartDrawer-Item-"] button[name=minus], [id^="CartDrawer-Item-"] button[name=plus]`);

    if (isLoading) {
      checkoutButton.classList.add('loading');
      spinner.classList.remove('hidden');
      [...cartItemElements, ...cartDrawerItemElements].forEach((button) => button.setAttribute('disabled', true));
      return;
    }

    checkoutButton.classList.remove('loading');
    spinner.classList.add('hidden');
    [...cartItemElements, ...cartDrawerItemElements].forEach((button) => button.removeAttribute('disabled'));
  }

  async addGifts(giftIds) {
    const config = fetchConfig();
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    const items = giftIds.map((giftId) => ({ quantity: 1, id: giftId }));
    const jsonBody = {
      items,
    };

    if (this.settings.cartType != 'page') {
      jsonBody.sections = this.cart.getSectionsToRender().map((section) => section.id);
      jsonBody.sections_url = window.location.pathname;
      this.cart.setActiveElement(document.activeElement);
    }

    try {
      config.body = JSON.stringify(jsonBody);
      const res = await fetch(`${Shopify.routes.root}cart/add.js`, config);
      const data = await res.json();

      if (data.status) {
        console.error(data.description);
      }

      this.cart.renderContents(data);
    } catch (err) {
      console.error(err);
    } finally {
      this.toggleLoading(false);
    }
  }

  conditionMatch(data) {
    if (this.settings.offerType === 'products_in_cart' && this.settings.offerCondition.length > 0) {
      let conditionRespected = null;
      if (this.settings.allProductsShouldBeInCart) {
        conditionRespected = true;
        this.settings.offerCondition.forEach((stringId) => {
          if (!data.items.find((item) => {
            return item.variant_id === parseInt(stringId, 10)
          })) {
            conditionRespected = false;
          }
        });
      } else {
        conditionRespected = false;
        this.settings.offerCondition.forEach((stringId) => {
          if (data.items.find((item) => item.variant_id === parseInt(stringId, 10))) {
            conditionRespected = true;
          }
        });
      }

      return conditionRespected;
    }

    if (this.settings.offerType === 'minimal_purchase' && this.settings.offerCondition >= 0) {
      const rate = parseFloat(Shopify.currency.rate);
      return data.total_price >= (this.settings.offerCondition * 100 * rate);
    }

    return false;
  }

  async onCartUpdate() {
    this.toggleLoading(true);
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    try {
      const data = await fetch(`${Shopify.routes.root}cart.js`, config).then((res) => res.json());

      if (!this.conditionMatch(data)) {
        console.log('condition does not match, removing gifts');
        const giftsToRemove = data.items.filter((item) => item.product_type === 'gift').map((item) => item.key);
        console.log('gifts to remove', giftsToRemove);
        if (giftsToRemove.length > 0) {
          const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
          cartItems.updateQuantities(giftsToRemove, 0);
        } else {
          this.toggleLoading(false);
        }
      } else {
        console.log('condition match, adding gifts');
        let giftsToAdd = [];
        this.settings.giftIds.forEach((giftId) => {
          const lineItem = data.items.find((item) => item.variant_id === giftId);
          if (!lineItem) {
            giftsToAdd.push(giftId);
          }
        });
        console.log('gifts to add', giftsToAdd);
        if (giftsToAdd.length > 0) {
          this.addGifts(giftsToAdd);
        } else {
          this.toggleLoading(false);
        }
      }
    } catch (err) {
      console.error(err);
      this.toggleLoading(false);
    }
  }
}

const offer = new Offer();
offer.init();